
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/seyfert",
      function () {
        return require("private-next-pages/cases/seyfert/index.tsx");
      }
    ]);
  